export default __webpack_public_path__ + "static/media/garage.3f80fc72.svg";